export function checkEmail(testString) {
    return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Z]{2,}$/i.test(testString);
}

export function devEnv() {
    return process && process.env && 'development' === process.env.NODE_ENV
}

const currencies = {
    'USD': {
        'code': 'USD',
        'pre_symbol': '$',
        'post_symbol': '',
        'decimal_digits': 2,
        'name': 'US Dollars'
    },
    'CAD': {
        'code': 'CAD',
        'pre_symbol': 'CA$',
        'post_symbol': '',
        'decimal_digits': 2,
        'name': 'Canadian Dollars'
    },
    'EUR': {
        'code': 'EUR',
        'pre_symbol': '€',
        'post_symbol': '',
        'decimal_digits': 2,
        'name': 'Euros'
    },
    'BTC': {
        'code': 'BTC',
        'pre_symbol': '',
        'post_symbol': ' BTC',
        'decimal_digits': 8,
        'name': 'Bitcoins'
    }
}

export function currencyFormat(amount, currency = 'USD') {
    if ('undefined' === typeof amount || null === amount) amount = 0
    if ('undefined' === typeof currency || null === currency) currency = 'USD'

    const curData = currencies[currency]

    return [
        curData['pre_symbol'],
        currencyRaw(amount, currency).toFixed(curData['decimal_digits']),
        curData['post_symbol']
    ].join('')
}

export function currencyRaw(amount, currency = 'USD') {
    const decimal = currencies[currency]['decimal_digits']

    return parseFloat(Math.round(amount * Math.pow(10, decimal)) / Math.pow(10, decimal))
}

export function jsonParse(jsonString) {
    if ('object' === typeof jsonString) return jsonString;
    if ('string' !== typeof jsonString) return undefined;

    let parsed;

    try {
        parsed = JSON.parse(jsonString);

    } catch (e) {
        try {
            parsed = JSON.parse(jsonString.replace(/'/g, '"'));

        } catch (e) {
            console.error(`error parsing JSON 2nd time: ${jsonString}`);
        }
    }
    // returns parsed JSON or undefined
    return parsed;
}



// WEBPACK FOOTER //
// ./src/lib/utilities.js